import classes from './loader.module.scss';

const Loader = () => {
  return <div className={classes.linear_loader} />;
};

export default Loader;
